import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar/Sidebar";
import { FaMoneyBillWave, FaLock, FaCheckCircle } from "react-icons/fa";
import axios from "../../../axiosInstance";

import "./Earnings.css";

function EarningsPage() {
  const [isEligible, setIsEligible] = useState(false); // Eligibility flag
  const [earnings, setEarnings] = useState({
    totalEarnings: 0,
    thisMonth: 0,
    today: 0,
  });
  const [loading, setLoading] = useState(true);
  const ID = localStorage.getItem("reporterId");
  const token = localStorage.getItem("sessiontoken");

  useEffect(() => {
    const checkEligibilityAndFetchEarnings = async () => {
      try {
        // Fetching eligibility status and earnings data
        const response = await axios.get(`/api/earnings/status?reporterId=${ID}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        // Update eligibility and earnings based on API response
        setIsEligible(response.data.isEligible);
        if (response.data.isEligible) {
          setEarnings(response.data.earnings);
        }
      } catch (error) {
        console.error("Error fetching earnings data:", error);
      } finally {
        setLoading(false);
      }
    };

    checkEligibilityAndFetchEarnings();
  }, [ID, token]);

  return (
    <div>
              <Sidebar />

 
    <div className="earnings-container">

      <div className="earnings-main">
        <div className="earnings-header">
          <h1>Earnings Dashboard</h1>
          <p>Track your earnings and financial performance here.</p>
        </div>

        {loading ? (
          <div className="loading-spinner">
            <p>Loading...</p>
          </div>
        ) : isEligible ? (
          // Show earnings details if eligible
          <div className="earnings-content">
            <div className="earnings-grid">
              <div className="earnings-card">
                <FaMoneyBillWave className="earnings-icon" />
                <h4>Total Earnings</h4>
                <p>${earnings.totalEarnings}</p>
              </div>
              <div className="earnings-card">
                <FaMoneyBillWave className="earnings-icon" />
                <h4>This Month</h4>
                <p>${earnings.thisMonth}</p>
              </div>
              <div className="earnings-card">
                <FaMoneyBillWave className="earnings-icon" />
                <h4>Today</h4>
                <p>${earnings.today}</p>
              </div>
            </div>
          </div>
        ) : (
          // Show eligibility message if not eligible
          <div className="eligibility-message">
            <FaLock className="lock-icon" />
            <h2>Not Eligible for Earnings</h2>
            <p>
              You are not eligible for earnings yet. Please meet the required
              criteria to unlock this feature.
            </p>
          </div>
        )}
      </div>
    </div>
    </div>
  );
}

export default EarningsPage;
